import { render, staticRenderFns } from "./mock-verification-code.vue?vue&type=template&id=f5d9625a&scoped=true&"
import script from "./mock-verification-code.vue?vue&type=script&lang=js&"
export * from "./mock-verification-code.vue?vue&type=script&lang=js&"
import style0 from "./mock-verification-code.vue?vue&type=style&index=0&id=f5d9625a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d9625a",
  null
  
)

export default component.exports